import(/* webpackMode: "eager" */ "/github/workspace/app/error.tsx");
